import React from "react";
// import specific_location_img from "../../images/hyderabad.jpg";
import { useNavigate } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { APP_NAME } from "../../Utils/constant";
import { handleApplyNow } from "../../Utils/navigation";

const Gurgaon = () => {
  const navigate = useNavigate();
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper gurgaon_banner">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - Gurgaon</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            <h1 className="page_title mt30 mb20">Manage Your Expenses Smartly: Get an Instant Personal Loan in Gurugram in No Time</h1>
            {/* <h3>Get an Instant Personal Loan in Hyderabad</h3> */}
            <p className="mt6">
            Located on the southern border of Delhi, Gurugram is a part of the National Capital Region of Delhi (it must be remembered that Gurugram is not in Delhi). It is a much-talked-about city in Haryana and is the second commercial capital of India after Mumbai. 1970 was a memorable year in Gurugram’s history when Maruti Suzuki Private Limited established its office there and then there was no looking back for this city. 
            </p><br/>
            <p>To date, nearly all the influential companies in India have their branches in Gurugram. This city is extravagantly lavish, offering — skyrocketing multi-storey flats, IT offices, renowned shopping malls, metro and glorious nightlife. Many desire to reside in this happening city. However, staying here and managing expenses is not a walk in the park. </p>
            <br />
            <p>To help you effectively navigate through the expenses, {APP_NAME} is here to lend a helping hand through its exceptional and affordable loan services. It is the best money lending app in India, offering a variety of loans customized to your needs with competitive interest rates and easy repayment options. </p>
            <br/>
            <h3>Types of Loans We Offer</h3>
            <p>We cater to a wide range of loan requirements, including instant personal loans online for salaried professionals, emergency personal loans, instant small personal loans, long-term loans, and many more. We have detailed below the types of loans we offer:</p>


<h4>1. Emergency Personal Loan in India</h4>
<p>Life is all about unpredictability and uncertainties. You never know what unfolds in the next moment. It can be good, bad or even worse. In times of medical emergency, money in hand is a make-or-break factor, giving much-needed assurance and boosting your morale. </p>
<p>{APP_NAME} stands as your all-weather friend in such critical times, offering emergency personal loans without any delay. Most importantly, we disburse the loan amount at a brisk pace because we believe you and your loved ones deserve good treatment.</p>
           
            <br />
            <h4>2. Instant Small Personal Loans</h4>
            <p>As discussed, life is all about unpredictability, unexpected expenses occurring out of nowhere are an integral part of our lives. In order to tackle them swiftly, {APP_NAME}, the best instantly borrow money app in India, offers Instant Small Personal Loans to salaried individuals. </p>
           
            <h4>3. Personal loan Online</h4>
            <p>Salaried professionals residing in Gurugram can apply for an instant personal loan online. From application to disbursal, every process is seamless and streamlined so you can secure the loan amount instantly without any hassle. Apart from that there are a number of loan types available tailored to meet your unique requirements.</p>
           
            <h4>Instant Personal Loan Apply: What Documents You Need</h4>
            <p>The loan application process in India is usually tiring and time-consuming, requiring a bundle of documents to prove your credibility. In contrast, we have broken the stereotype by asking for a minimal number of documents to apply for — instant small personal loan, emergency personal loan, short-term loan, long-term loan, etc at {APP_NAME}. Here is a list of the documents you need to have before personal loan online apply.</p>
            <ul className="content_list">
                <li>Identity Proof (such as Aadhar card, Voter card, etc)</li>
                <li>Address Proof</li>
                <li>PAN Card</li>
                <li>Income Proof (such as Salary Slip, Bank Statement, etc)</li>
                <li>Passport-size Photographs</li>
            </ul>
           
            <div className="button_container flex justify-center mt30">
              <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Gurgaon;
